import styled from 'styled-components';

export const HeadlineH1 = styled.h1`
  line-height: 40px;
  margin-top: 15px;
  font-size: 28px;
  font-weight: lighter;
`;
export const HeadlineH2 = styled.h2`
  font-size: 25px;
  font-weight: lighter;
`;

export const HeadlineH3 = styled.h3`
  font-size: 20px;
  font-weight: lighter;
  margin-bottom: 0;
  margin-top: 40px;
`;



// WEBPACK FOOTER //
// ./src/components/text/Headlines.js